// @mui
import { Button, Box, Typography } from '@mui/material';
// components

// ----------------------------------------------------------------------

export default function LoginForm({ setSelectedForm }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: { xs: '350px', sm: '408px' },
        p: '59px 43px 72.98px 38px',
        boxShadow: (theme) => theme.customShadows.card,
        minHeight: '500px',
        maxHeight: '600px',
        borderRadius: '20px',
        my: 'auto',
        bgcolor: 'background.paper',
        mx: 'auto',
      }}
    >
      <Typography variant="h3" sx={{ lineHeight: 'normal', color: 'text.titles' }}>
        Get Started
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 300, lineHeight: '20.2px', mt: '25px' }}>
        Welcome to Our Community of Support! Choose Your Role to Get Started.
      </Typography>

      <Button 
        variant="contained" 
        sx={{ 
          borderRadius: 0, 
          width: { xs: '250px', sm: '312px' }, 
          height: '48px', 
          bgcolor: 'background.green',
          mb: '16px',
          mt: '21px',
          '&:hover': {
            bgcolor: 'background.green',
            opacity: 0.9,
          },
        }} 
        onClick={() => setSelectedForm('teacher')}
      >
        Become a Mentee
      </Button>
      <Button
        variant="contained"
        color="main"
        sx={{ borderRadius: 0, width: { xs: '250px', sm: '312px' }, height: '48px' }}
        onClick={() => setSelectedForm('coach')}
      >
        Become an Edifier
      </Button>
    </Box>
  );
}
